import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative h-[600px] overflow-hidden">
      <img
        src="https://mgx-backend-cdn.metadl.com/generate/images/1032187/2026-03-16/aee65667-b922-4be5-8f17-56f3e06df1c4.png"
        alt="FMA수학학원"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1E3A5F]/90 to-[#1E3A5F]/50" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
        <div className="max-w-2xl text-white">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
            <i className="ri-star-line text-[#F59E0B] text-sm" />
            <span className="text-sm font-medium">FIELDS MATHEMATICS ACADEMY — 중고등부 전문</span>
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-4">
            더 나은,<br />
            그 이상의 목표를 위한<br />
            <span className="text-[#F59E0B]">수학의 혁신!</span>
          </h1>
          <p className="text-lg text-slate-200 mb-8 leading-relaxed">
            정통파 수리논술 강사에게<br />
            저학년부터 정확하고 제대로 배우자!
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="tel:010-2368-3385"
              className="inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-[#F59E0B] hover:bg-[#D97706] text-[#1E3A5F] font-bold rounded-lg text-sm transition-colors cursor-pointer gap-2"
            >
              <i className="ri-phone-line" />
              010-2368-3385
            </a>
            <a
              href="https://blog.naver.com/fmasky"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-transparent border border-white text-white hover:bg-white/10 rounded-lg text-sm font-medium transition-colors cursor-pointer"
            >
              블로그 바로가기
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
